import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

import type { RouteConfig } from '@shared/types/common.types';

import { getLayoutViewValue } from './getLayoutViewValue';
import { LayoutViewBridge, LayoutViewContext } from './LayoutViewContext';

interface LayoutViewContextProviderProps {
  ROUTES: RouteConfig[];
}

const LayoutViewContextProvider = ({ children, ROUTES }: PropsWithChildren<LayoutViewContextProviderProps>) => {
  const location = useLocation();

  const value = useMemo(() => {
    const result = getLayoutViewValue({ location, ROUTES });

    LayoutViewBridge.setGetLayoutViewBridge(() => result);

    return result;
  }, [location, ROUTES]);

  return <LayoutViewContext.Provider value={value}>{children}</LayoutViewContext.Provider>;
};

export default LayoutViewContextProvider;
